import {
	BeforeCapture, DragStart, DragUpdate, DropResult,
	OnBeforeCaptureResponder,
	OnBeforeDragStartResponder, OnDragEndResponder,
	OnDragStartResponder,
	OnDragUpdateResponder, ResponderProvided,
} from 'react-beautiful-dnd';
import {EventType, IDragDropManager, Subscriber} from './types';

export class DragDropManagerRef {
	current: IDragDropManager;
}


export interface CurrentItemInfo {
	type: string,
	id: string,
	source: string,
}


export class DragDropManager implements IDragDropManager {
	private subscriptions: Subscriber[] = [];
	private _currentItem: CurrentItemInfo;

	public getCurrentItemInfo() {
		return this._currentItem ? {...this._currentItem} : null;
	}

	public onBeforeCapture(callback: OnBeforeCaptureResponder): Subscriber {
		const sub = this.buildSubscription(callback, EventType.BeforeCapture);
		this.subscriptions.push(sub);
		return sub;
	}

	public onBeforeDragStart(callback: OnBeforeDragStartResponder): Subscriber {
		const sub = this.buildSubscription(callback, EventType.BeforeDragStart);
		this.subscriptions.push(sub);
		return sub;
	}

	public onDragStart(callback: OnDragStartResponder): Subscriber {
		const sub =this.buildSubscription(callback, EventType.DragStart);
		this.subscriptions.push(sub);
		return sub;
	}

	public onDragUpdate(callback: OnDragUpdateResponder): Subscriber {
		const sub = this.buildSubscription(callback, EventType.DragUpdate);
		this.subscriptions.push(sub);
		return sub;
	}

	public onDragEnd(callback: OnDragEndResponder): Subscriber {
		const sub = this.buildSubscription(callback, EventType.DragEnd);
		this.subscriptions.push(sub);
		return sub;
	}

	public triggerBeforeCapture(before: BeforeCapture) {
		const subscribersToCall = this.subscriptions.filter(sub => sub.eventType === EventType.BeforeCapture);
		for (const sub of subscribersToCall) {
			sub.callback && sub.callback(before);
		}
	}

	public triggerBeforeDragStart(start: DragStart) {
		this._currentItem = {
			id: start.draggableId,
			type: start.type,
			source: start.source.droppableId,
		} as CurrentItemInfo;
		const subscribersToCall = this.subscriptions.filter(sub => sub.eventType === EventType.BeforeDragStart);
		for (const sub of subscribersToCall) {
			sub.callback && sub.callback(start);
		}
	}

	public triggerDragStart(start: DragStart, provided: ResponderProvided) {
		const subscribersToCall = this.subscriptions.filter(sub => sub.eventType === EventType.DragStart);
		for (const sub of subscribersToCall) {
			sub.callback && sub.callback(start, provided);
		}
	}

	public triggerDragUpdate(update: DragUpdate, provided: ResponderProvided) {
		const subscribersToCall = this.subscriptions.filter(sub => sub.eventType === EventType.DragUpdate);
		for (const sub of subscribersToCall) {
			sub.callback && sub.callback(update, provided);
		}
	}

	public triggerDragEnd(result: DropResult, provided: ResponderProvided) {
		const subscribersToCall = this.subscriptions.filter(sub => sub.eventType === EventType.DragEnd);
		for (const sub of subscribersToCall) {
			sub.callback && sub.callback(result, provided);
		}
		this._currentItem = null;
	}

	public unsubscribe(subscriber: Subscriber) {
		this.subscriptions = this.subscriptions.filter(sub => sub !== subscriber);
	}

	private buildSubscription(callback: any, eventType: EventType) {
		return {
			callback: callback,
			eventType: eventType,
		} as Subscriber;
	}

}
